import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Legal — terms and agreements. */
export function LegalIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M12 4.2v15.6M5.6 7.4h12.8" />
      <path d="M8.2 7.4 5.4 13a2.9 2.9 0 0 0 5.6 0L8.2 7.4Z" />
      <path d="M15.8 7.4 13 13a2.9 2.9 0 0 0 5.6 0l-2.8-5.6Z" />
    </PortalIcon>
  );
}
